import { render, staticRenderFns } from "./ConfigAlertMatrixHookshot.vue?vue&type=template&id=b83fae36&scoped=true"
import script from "./ConfigAlertMatrixHookshot.vue?vue&type=script&lang=js"
export * from "./ConfigAlertMatrixHookshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83fae36",
  null
  
)

export default component.exports